<template>
  <div class="meaasge-video">
    <Xgplayer
      id="messageVideoChild"
      x5-playsinline
      playsinline
      webkit-playsinline
      :config="Videoconfig"
      @player="Player = $event"
      :class="startStyle"
    />
    <img src="https://dazengzhang-xingmahui.oss-cn-beijing.aliyuncs.com/xmh-content/2023/03/09/35416c71951749f3bfdb96a13af4a4f3.jpg" alt="简介图片">
  </div>
</template>
<script>
import { log } from "console";
import Xgplayer from "xgplayer-vue";

export default {
  components: {
    Xgplayer
  },
  data() {
    return {
      Videoconfig: {
        id: "messageVideoChild", //元素id
        poster: 'https://dazengzhang-xingmahui.oss-cn-beijing.aliyuncs.com/xmh-content/2023/03/09/02ee71802ecb44f9bd165b45dd043c7f.jpg',
        url: "https://image-mom.feihe.com/upload/2023/03/09/video/yemianzhanshi.mp4", //视频地址
        videoInit: true,
        fitVideoSize: "fixWidth",
        fitVideoSize: "fixHeight",
        playsinline: true, //设置ios全屏问题
        "x5-video-player-type": "h5-page", //解决ios安卓播放自动全屏问题
        "x5-video-player-fullscreen": true, //解决自动全屏问题
        "x5-video-orientation": "portraint", //横竖屏
        closeVideoClick: true, //禁止pc点击屏幕暂停（功能与现实相反）
        closeVideoTouch: true, //禁止手机点击屏幕暂停（功能与现实相反）
        loop: true, //循环播
        whitelist: ["iPhone", "Android"], //白名单（支持个别机型）
        hasStart: true,
        ignores: ["replay", "enter", "mobile", "error"],
      }, //播放器配置
      Player: null, //播放器实例

    };
  },
  // 监听属性 类似于data概念
  computed: {
    // 计算视频带不带播放按钮
    startStyle() {
      if (!this.isWifi) {
        return "xgplayer xgplayer-mobile xgplayer-skin-default lang-is-en  xgplayer-playing xgplayer-inactive xgplayer-pause videoDisPlayer";
      } else {
        return "xgplayer xgplayer-mobile xgplayer-skin-default xgplayer-pause  lang-is-en xgplayer-playing";
      }
    },
  },
  // 监控data中的数据变化
  watch: {},
  methods: {
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    sensors.track("salemng_online_pageview", {});
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    // console.log(this.Player)
    // this.Player.play();

    // this.Player.once("ready", () => {
    //   document.addEventListener(
    //     "WeixinJSBridgeReady",
    //     function() {
    //       document.getElementsByTagName("video")[0].play();
    //     },
    //     false
    //   );
    // });
    $("video").on("play", () => {
      if (!$("video")[0]) return false;
      console.log($("video"), '视频播放了')
      sensors.track("salemng_online_page_videoplay", {});
      // this.currentTimebug = Math.floor($("video")[0].currentTime);
    })
  },
};
</script>
<style lang="less" scoped>
.meaasge-video {
  width: 100%;
  height: 100%;
  overflow: auto;
  #messageVideoChild {
    width: 100% !important;
    height: 210px !important;
    background-size: 100% 100%;
    background-position: center center;
    z-index: 10;
  }
  img {
    width: 100%;
    height: auto;
    display: block;
  }
}
</style>
